var FactoryRequiredCtrl = function ($scope, $log, customerModelService, maintenanceModelService) {

    Object.defineProperty($scope, 'showLineComment', {
        enumerable: false,
        configurable: false,
        set: function (value) {
            throw new Error('You can not set read only property');
        },
        get: function () {
            return window.appSettings.displayFrsLineComments || false;
        }
    });
    
    //init
    //
    //@description
    //Entry point into controller client object
    function init() {
        //factory required services storage
        $scope.factoryRequiredServices = customerModelService.getFactoryRequiredServices();
        var currentAppointment = customerModelService.getCurrentAppointment();
        if (currentAppointment) {
            maintenanceModelService.updateSelectedMaintenanceInterval(currentAppointment.mileage.value)
        } else if ($scope.factoryRequiredServices.affectiveMileage) {
            //update maintenance intervals according to affective mileage
            maintenanceModelService.updateSelectedMaintenanceInterval($scope.factoryRequiredServices.affectiveMileage.value);
        }
        //maintenance services intervals
        $scope.maintenanceIntervals = maintenanceModelService.getMaintenanceIntervals();

        var selectedInterval = _.find($scope.maintenanceIntervals, { selected: true });
        if (selectedInterval) selectedIntervalChanged(selectedInterval);
    };
    //selectedIntervalChanged
    //
    //@param {Object} current selected maintenance interval
    //
    //@description
    //Notifies other components that current mileage was changed
    function selectedIntervalChanged(interval) {
        customerModelService.getCurrentVehicle().setCurrentMaintenanceInterval(interval);
    };
    //getSelectedMileage
    //
    //@param {Array} array of maintenance intervals
    //
    //@description
    //Get mileage of the selected maintenance interval
    $scope.getSelectedMileage = function (maintenanceIntervals) {
        var interval = maintenanceIntervals.filter(function (el) {
            return el.selected;
        });
        return interval.length ? interval[0] : undefined;
    };

    //setSelectedInterval
    //
    //@param {object} interval to select
    //
    //@description
    //Method calls when user cliks on any of interval items
    // and makes it selected
    $scope.setSelectedInterval = function (interval) {
        //reset maintenance menu link
        $scope.$emit('FactoryRequiredCtrl:changeInterval');

        $scope.maintenanceIntervals.forEach(function (el) {
            el.selected = false;
        });
        interval.selected = true;
        selectedIntervalChanged(interval);

        function processServices(currentServices, newServices) {
            _.forEach(newServices, function (s) {
                if (_.find(currentServices, { id: s.id })) {
                    s.selected = currentServices.selected;
                    s.comment = currentServices.comment;
                }
            });
            return newServices;
        }

        var appointment = customerModelService.getCurrentAppointment();

        var promise;
        if (appointment) promise = appointment.resolveFactoryRequiredServices("mileage", interval.mileage);
        else promise = maintenanceModelService.resolveFactoryRequiredServices(customerModelService.getCurrentVehicle(), interval.mileage, true);

        $scope.bookAppoimentServicesLoader.addPromise(
            promise.then(function (result) {
                _.remove(result, _.isNull);
                return processServices(customerModelService.getFactoryRequiredServices() || [], result);
            }).then(function (result) {
                customerModelService.setFactoryRequiredServices(result);
                $scope.factoryRequiredServices = customerModelService.getFactoryRequiredServices();

                var p;
                if (appointment) p = appointment.resolveDealerRecommendedServices("mileage", interval.mileage);
                else p = maintenanceModelService.resolveDealerRecommendedServices(customerModelService.getCurrentVehicle(), interval.mileage, true);

                return p.then(function (result) {
                    return processServices(customerModelService.getDealerRecommendedServices() || [], result);
                });


            }).then(function (result) {
                customerModelService.setDealerRecommendedServices(result);
            })
        );
    };

    var frsListener = $scope.$on('bookAppoimentServicesCtrl:reloadFRS', function () {
        $scope.factoryRequiredServices = customerModelService.getFactoryRequiredServices();
    });

    function updatePackage(service) {
        service.children.forEach(function (el) {
            el.selected = true;
        });
        var services = $scope.factoryRequiredServices.filter(function (el) {
            return el.id === service.id;
        });
        return services;

    };

    $scope.onBreakPackage = function (p, service) {
        var services = p.children.map(function (el) {
            var newEl = angular.copy(el);
            newEl.selected = false;
            return newEl;
        });
        $scope.factoryRequiredServices = $scope.factoryRequiredServices.concat(services);
        customerModelService.setFactoryRequiredServices($scope.factoryRequiredServices, true);
    };

    $scope.onAddService = function (isPackage, service) {
        if (isPackage) {
            customerModelService.setFactoryRequiredServices(updatePackage(service), true);
        } else {
            var pack = $scope.factoryRequiredServices.filter(function(el) {
                return window.appSettings.enablePackages && (el.children instanceof Array) && (el.children.length > 0)
            })[0];
            var selectedServices = $scope.factoryRequiredServices.filter(function(el) {
                if(pack) {
                    return el.selected && pack.id !== el.id;
                } else {
                    return false;
                }
            });
            if(pack && pack.children.length == selectedServices.length) {
                pack.selected = true;
                customerModelService.setFactoryRequiredServices(updatePackage(pack), true);
            }
        }
        $scope.factoryRequiredServices = customerModelService.getFactoryRequiredServices();
    };

    $scope.$on('$destroy', function () {
        frsListener();
    });

    //init current controller
    init();
};
FactoryRequiredCtrl.$inject = ['$scope', '$log', 'customerModelService', 'maintenanceModelService'];

module.exports = FactoryRequiredCtrl;
